<div class="card m-0 bg-transparent">
  <div class="card-body">
    <form [formGroup]="mediaform">
      <div class="mb-3" *ngIf="config?.media_type != 'file'">
        <label class="offcanvas-header-text w-100" style="text-align: left">
          Select Sources
        </label>
        <ng-select
          [items]="sourcesList"
          class="custom-select"
          bindLabel="name"
          bindValue="key"
          placeholder="Select Sources"
          [multiple]="true"
          formControlName="sources"
          (change)="updatelist($event)"
        >
        </ng-select>
      </div>
      <div class="mb-3" *ngIf="config?.media_type == 'file'">
        <label class="offcanvas-header-text w-100" style="text-align: left">
          Select Extensions
        </label>
        <ng-select
          [items]="extensionsList"
          class="custom-select"
          bindLabel="name"
          bindValue="key"
          placeholder="Select Extensions"
          [multiple]="true"
          formControlName="allowed_extensions"
          (change)="updatelist($event)"
        >
        </ng-select>
      </div>
      <div class="row d-flex justify-content-between align-items-center mb-3">
        <div class="col-10 d-flex align-items-center">
          <label class="offcanvas-header-text w-100" style="text-align: left">
            Allow Multiple
            <i
              class="mdi mdi-information-outline font-size-16 ms-1"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Add Tags to your Post."
            ></i>
          </label>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <ui-switch
            [color]="offcanvasColors.activeColor"
            [switchColor]="offcanvasColors.switchColor"
            [defaultBgColor]="offcanvasColors.bgColor"
            [defaultBoColor]="offcanvasColors.borderColor"
            [checkedTextColor]="offcanvasColors.activeTextColor"
            [uncheckedTextColor]="offcanvasColors.offTextColor"
            uncheckedLabel="Off"
            [checked]="enableMultiple"
            checkedLabel="On"
            size="small"
            class="me-1"
            (change)="togglePostTags($event)"
          ></ui-switch>
        </div>
      </div>
      <div class="row mb-3">
        <div *ngIf="config?.media_type == 'image'"  class="mb-3" class="mb-3 col-6">
          <label
            for="text-color"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            Max Files
          </label>
          <div
            title="Using format option"
            class="input-group offcanvas-border-primary border rounded-2"
          >
            <input
              type="number"
              id="lablecolor"
              formControlName="max_files"
              placeholder="Label"
              class="form-control input-lg offcanvas-primary border-0 ng-untouched ng-pristine ng-valid ng-star-inserted"
              (change)="onFormChange()"
            />
          </div>
        </div>

        <div *ngIf="config?.media_type == 'image' || config?.media_type == 'video' || config?.media_type == 'file'"  class="mb-3" [ngClass]="{'col-12': config?.media_type == 'video', 'col-6': config?.media_type == 'image'}">
          <label
            for="text-color"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            Max Size(MB)
          </label>
          <div
            title="Using format option"
            class="input-group offcanvas-border-primary border rounded-2"
          >
            <input
              type="number"
              id="lablecolor"
              formControlName="max_size_mb"
              placeholder="max size mb"
              class="form-control input-lg offcanvas-primary border-0 ng-untouched ng-pristine ng-valid ng-star-inserted"
              (change)="onFormChange()"
            />
          </div>
        </div>
        <div class="mb-3 col-6" *ngIf="config?.media_type == 'video'">
          <label
            for="text-color"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            Duration limit
          </label>
          <div
            title="Using format option"
            class="input-group offcanvas-border-primary border rounded-2"
          >
            <input
              type="number"
              id="lablecolor"
              formControlName="duration_limit_sec"
              (change)="onFormChange()"
              placeholder="Duration limit Second"
              class="form-control input-lg offcanvas-primary border-0 ng-untouched ng-pristine ng-valid ng-star-inserted"
            />
          </div>
        </div>
        <div *ngIf="config?.media_type == 'image'" class="col-12 m-0">
          <label
            for="card-type"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            aspectRatio
          </label>
          <select
            id="card-type"
            formControlName="aspect_ratio"
            class="form-select offcanvas-primary ng-pristine ng-valid ng-touched border-0 shadow-none"
            (change)="onAspectChange()"
          >
            <option [ngValue]="'1:1'">1:1</option>
            <option [ngValue]="'4:3'">4:3</option>
            <option [ngValue]="'3:2'">3:2</option>
            <option [ngValue]="'16:9'">16:9</option>
            <option [ngValue]="'2:1'">2:1</option>
            <option [ngValue]="'9:16'">9:16</option>
            <option [ngValue]="'4:5'">4:5</option>
            <option [ngValue]="'5:4'">5:4</option>
          </select>
        </div>
      </div>

      <div *ngIf="config?.media_type == 'image'" class="row d-flex justify-content-between align-items-center mb-3">
        <div class="col-10 d-flex align-items-center">
          <label class="offcanvas-header-text w-100" style="text-align: left">
            Allow Crop
            <i
              class="mdi mdi-information-outline font-size-16 ms-1"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Add Tags to your Post."
            ></i>
          </label>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <ui-switch
            [color]="offcanvasColors.activeColor"
            [switchColor]="offcanvasColors.switchColor"
            [defaultBgColor]="offcanvasColors.bgColor"
            [defaultBoColor]="offcanvasColors.borderColor"
            [checkedTextColor]="offcanvasColors.activeTextColor"
            [uncheckedTextColor]="offcanvasColors.offTextColor"
            uncheckedLabel="Off"
            [checked]="enableCrop"
            checkedLabel="On"
            size="small"
            class="me-1"
            (change)="togglecrop($event)"
          ></ui-switch>
        </div>
      </div>
      <div *ngIf="config?.media_type == 'image'" class="row d-flex justify-content-between align-items-center mb-3">
        <div class="col-10 d-flex align-items-center">
          <label class="offcanvas-header-text w-100" style="text-align: left">
            Allow Compression
            <i
              class="mdi mdi-information-outline font-size-16 ms-1"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Add Tags to your Post."
            ></i>
          </label>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <ui-switch
            [color]="offcanvasColors.activeColor"
            [switchColor]="offcanvasColors.switchColor"
            [defaultBgColor]="offcanvasColors.bgColor"
            [defaultBoColor]="offcanvasColors.borderColor"
            [checkedTextColor]="offcanvasColors.activeTextColor"
            [uncheckedTextColor]="offcanvasColors.offTextColor"
            uncheckedLabel="Off"
            [checked]="enableCompression"
            checkedLabel="On"
            size="small"
            class="me-1"
            (change)="togglecompression($event)"
          ></ui-switch>
        </div>
      </div>
      <div *ngIf="config?.media_type == 'image'" formGroupName="compression">
        <div class="mb-3">
          <label
            for="text-color"
            class="offcanvas-header-text w-100"
            style="text-align: left"
          >
            Image Quality
          </label>
          <md-slider
            class="w-100"
            labeled
            ticks
            [step]="0.1"
            [min]="0"
            [max]="1"
            [value]="mediaform?.get('compression').get('image_quality')?.value"
            (change)="valueChange($event)"
          ></md-slider>
        </div>
        <div class="row">
          <div class="col-6 mb-3">
            <label
              for="max_width"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Max width
            </label>
            <div
              title="Using format option"
              class="input-group offcanvas-border-primary border rounded-2"
            >
              <input
                type="number"
                id="max_width"
                formControlName="max_width"
                placeholder="Max Width"
                class="form-control input-lg offcanvas-primary border-0 ng-untouched ng-pristine ng-valid ng-star-inserted"
               (change)="onWidthChange()"
              />
            </div>
          </div>
          <div class="col-6 mb-3">
            <label
              for="text-color"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Max height
            </label>
            <div
              title="Using format option"
              class="input-group offcanvas-border-primary border rounded-2"
            >
              <input
                type="number"
                id="lablecolor"
                formControlName="max_height"
                placeholder="max size mb"
                class="form-control input-lg offcanvas-primary border-0 ng-untouched ng-pristine ng-valid ng-star-inserted"
                (change)="onHeightChange()"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-between align-items-center" *ngIf="config?.media_type == 'image'">
        <div class="col-10 d-flex align-items-center">
          <label class="offcanvas-header-text w-100" style="text-align: left">
            Create Thumbnail
          </label>
        </div>
        <div class="col-2 d-flex justify-content-end">
          <ui-switch
            [color]="offcanvasColors.activeColor"
            [switchColor]="offcanvasColors.switchColor"
            [defaultBgColor]="offcanvasColors.bgColor"
            [defaultBoColor]="offcanvasColors.borderColor"
            [checkedTextColor]="offcanvasColors.activeTextColor"
            [uncheckedTextColor]="offcanvasColors.offTextColor"
            uncheckedLabel="Off"
            [checked]="enableBase64"
            checkedLabel="On"
            size="small"
            class="me-1"
            (change)="toggleBase64($event)"
          ></ui-switch>
        </div>
      </div>
    </form>
  </div>
</div>
